<template>
  <div class="alert">
    <div class="alert_icon">
      <font-awesome-icon :icon="['fas', 'exclamation']" />
    </div>
    <p>
      <slot />
    </p>
  </div>
</template>

<script>
export default {
  //
}
</script>

<style lang="less">
	.alert {
		display: flex;
		align-items: center;

		@media screen and (max-width: 768px) {
			flex-direction: column;
		}

		&_icon {
			width: 38px;
			height: 38px;
			display: flex;
			align-items: center;
			flex-shrink: 0;
			justify-content: center;
			background-color: #FFE356;
			border-radius: 50%;
			margin-right: 10px;

			@media screen and (max-width: 768px) {
				margin-right: 0;
				margin-bottom: 11px;
			}
		}

		p {
			font-family: 'Roboto', Arial, sans-serif;
			font-weight: 300;
			font-size: 14px;

			@media screen and (max-width: 768px) {
				text-align: center;
			}

			a {
				color: black;
				text-decoration: none;
				border-bottom: 1px dashed #000;
			}
		}
	}
</style>
